// SPDX-License-Identifier: LicenseRef-VicZhuProprietary
// SPDX-FileCopyrightText: 2026 Vic Zhu <viczhu2014@gmail.com>

import GroupsIcon from '@mui/icons-material/Groups'
import ClinicTeamList from './ClinicTeamList'

// List-only resource: the page fetches its own data (the master's sub-accounts)
// and posts to the create-sub-account endpoint. Registered in App.tsx so the
// route /clinic-team exists; the Menu entry is role-gated to masters.
export default {
  list: ClinicTeamList,
  icon: GroupsIcon,
}
